import React, { useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField,
  CircularProgress,
  Box
} from '@mui/material';
import { useDispatch } from 'react-redux';
import ZXingScanner from '../../components/scanner/index';
import { useUpdateBarcode } from './loads.hooks';
import { showAlert } from '../../store/slices/alertSlice';
import { constants } from '../../constants';

export default function UpdateBarcode({ item, open, onClose, loadid, onBarcodeUpdate, mode = constants.BARCODE_SCAN_MODE.CAMERA }) {
  const dispatch = useDispatch();
  const inputRef = useRef();

  const { mutate, isLoading: isUpdating, isError, error } = useUpdateBarcode(
    (data, variables) => {
      if (onBarcodeUpdate && item) {
        onBarcodeUpdate(item.id, variables.newBarcode);
      }
  
      dispatch(showAlert({ severity: 'success', title: 'Barcode updated successfully!' }));
      onClose();
       },
    (error) => {
      dispatch(showAlert({ severity: 'error', title: error?.message || 'Barcode updation failed, Try later' }));
    }
  );

  const handleBarcodeUpdate = (newBarcode) => {

    if (!newBarcode) return;
    mutate({ id: item.id, newBarcode, loadid });
    if (mode === constants.BARCODE_SCAN_MODE.SCANNER) {
      inputRef.current.value = ''; // Clear input
      inputRef.current.focus();    // Keep focus for next entry
    }
    };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Barcode</DialogTitle>
      <DialogContent dividers>
        {item ? (
          <>
            <Typography><strong>Product Code:</strong> {item.productcode}</Typography>
            <Typography><strong>Name:</strong> {item.name}</Typography>
            <Typography><strong>Current Barcode:</strong> {item.barcode}</Typography>

            {mode === constants.BARCODE_SCAN_MODE.CAMERA ? (
              <ZXingScanner onScan={handleBarcodeUpdate} />
            ) : (
              <TextField
                inputRef={inputRef}
                autoFocus
                fullWidth
                label="Enter or Scan Barcode"
                placeholder="Scan / Type and enter"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !isUpdating) {
                    handleBarcodeUpdate(e.target.value.trim());
                  }
                }}
                sx={{ mt: 2 }}
                disabled={isUpdating} // disable input while updating
              />
            )}
            {/* Loader overlay */}
            {isUpdating && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                display="flex"
                justifyContent="center"
                alignItems="center"
                bgcolor="rgba(255, 255, 255, 0.7)"
                zIndex={10}
              >
                <CircularProgress />
              </Box>
            )}
          </>
        ) : (
          <Typography>Loading...</Typography>
        )}

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={isUpdating}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
